module.exports = __webpack_public_path__ + "img/Mastercard-logo.810a7266.png";